<template>
  <div>
    <titulo-modulo titulo="Configurações Compra Prazo"></titulo-modulo>
    <!-- <v-card flat rounded="lg" class="mt-3"> -->
    <v-overlay v-if="carregando">
      <v-list-item>
        <v-list-item-icon>
          <v-progress-circular size="55" indeterminate></v-progress-circular>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title"> Aguarde... </v-list-item-title>
          <v-list-item-subtitle class="subtitle-1">
            Buscando parâmetros
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-overlay>
    <v-alert v-else-if="parametros == null" type="info" text class="mt-4">
      Parâmetros não localizados
    </v-alert>
    <config-senha-compras-prazo v-else-if="parametros.codigo_valido" />
    <template v-else>
      <v-stepper vertical flat class="mt-3" rounded="lg" v-model="step">
        <v-stepper-step step="1"> Enviar Código de Segurança </v-stepper-step>
        <v-stepper-content class="pl-0 pt-0" step="1">
          <enviar-codigo-seguranca />
        </v-stepper-content>
        <v-stepper-step step="2"> Validar Código </v-stepper-step>
        <v-stepper-content class="pl-0 pt-0" step="2">
          <validar-codigo-seguranca />
        </v-stepper-content>       
      </v-stepper>
    </template>
    <!-- </v-card> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import ConfigSenhaComprasPrazo from "./components/ConfigSenhaComprasPrazo.vue";
import EnviarCodigoSeguranca from "./components/EnviarCodigoSeguranca.vue";
import ValidarCodigoSeguranca from "./components/ValidarCodigoSeguranca.vue";
export default {
  computed: {
    ...mapState("configComprasPrazo", ["step","parametros"]),
  },
  data: () => ({
    carregando: true,
  }),
  components: {
    TituloModulo,
    EnviarCodigoSeguranca,
    ValidarCodigoSeguranca,
    ConfigSenhaComprasPrazo,
  },
  methods: {
    ...mapActions("configComprasPrazo", ["buscarParametros"]),
  },
  async mounted() {
    this.carregando = true;
    await this.buscarParametros();
    this.carregando = false;
  },
};
</script>

<style>
</style>